import React from 'react';
import { IconProps } from './types';

const StarHalfO: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={1.0625 * size}
    height={size}
    viewBox="0 0 34 32"
  >
    <path
      fill={!ignoreColor ? color : undefined}
      d="M34.35 12.15c-0.15-0.4-0.5-0.7-0.95-0.8l-10.45-1.5-4.7-9.2c-0.2-0.4-0.6-0.65-1.050-0.65-0.2 0-0.35 0.050-0.55 0.15s-0.4 0.3-0.5 0.5l-4.65 9.25-10.5 1.45c-0.45 0.050-0.8 0.35-0.95 0.8-0.15 0.4 0 0.9 0.3 1.2l7.6 7.15-1.8 10.15c-0.1 0.45 0.1 0.85 0.45 1.1s0.85 0.3 1.25 0.1l9.35-4.8 9.35 4.8c0.4 0.2 0.85 0.15 1.25-0.1 0.35-0.25 0.55-0.7 0.45-1.1l-0.75-4.2-1-5.95 7.6-7.2c0.3-0.3 0.4-0.75 0.25-1.15zM25.15 20.050l1.15 6.55 0.8 4.1-9.9-5v-24.45l4.95 9.75 11.1 1.4-8.1 7.65z"
    />
  </svg>
);

export default StarHalfO;
